<template>
  <no-existing-reward-link-shell>
    <router-view />
  </no-existing-reward-link-shell>
</template>

<script>
import NoExistingRewardLinkShell from '../components/shells/NoExistingRewardLinkShell'

export default {
  name: 'NoExistingRewardLinkView',
  components: { NoExistingRewardLinkShell }
}
</script>
